const initialState = {
    arr: []
}

const uploadFilesRed = (state = initialState, action) => {
    switch(action.type){
        case 'UPLOAD_FILES' : {
            return {
                ...state,
                arr: action.arr
            }
        }
        default: {
            return state
        }
    }
}

export default uploadFilesRed